if (typeof CartRewardsProgress !== 'function') {
  class CartRewardsProgress extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Get reference to cart sidebar
      
      
      // Debounce timer to prevent multiple simultaneous calls
      this.checkModalTimer = null;

      // Listen for cart updates - event bubbles from cart-form element
      document.addEventListener('cart-updated', () => {
          this.scheduleCheck();
      });

      // Listen for cart-opened event (dispatched when cart sidebar is fully opened)
      document.addEventListener('cart-opened', () => {
        this.scheduleCheck();
      });

      // site-cart-popup is fully opened
      document.addEventListener('cart-popup-opened', () => {
        
        this.scheduleCheck();
      });
    }
    
    scheduleCheck() {
      this.closeAllModals();
      if (this.isDrawerOpen()) {
        setTimeout(() => {
          this.checkAndShowFreeProductModal();
        }, 500);
      }
    }


    isDrawerOpen() {
      const drawer = document.getElementById('site-cart-sidebar');
      const popup = document.getElementById('site-cart-popup');
      return drawer && (drawer.classList.contains('sidebar--opened') || drawer.opened === true) || popup && (popup.classList.contains('sidebar--opened') || popup.opened === true);
    }

    closeAllModals() {
      const modalCommon = document.getElementById('modal-common');
          
      if (modalCommon && typeof modalCommon.hide === 'function' && modalCommon.classList.contains('active')) {
        modalCommon.hide();
      }
    }

    async checkAndShowFreeProductModal() {
      // Get current cart total from data attribute (value is in cents)
      const cartRewardsElement = document.querySelector('cart-rewards-progress');
      if (!cartRewardsElement) return;

      const cartTotal = parseInt(document.querySelector('[data-cart-total-value]').textContent) || 0;

      // Get cart product IDs - fetch fresh cart data to ensure accuracy
      const cartProductIds = await this.getCartProductIds();

      // Check each milestone for free_product tiers
      const milestones = document.querySelectorAll('.cart-rewards-progress__milestone[data-type="free_product"]');

      console.log('milestones', milestones);
      console.log('cartTotal', cartTotal);
      console.log('cartProductIds', cartProductIds);
      
      milestones.forEach(milestone => {
        const tierNumber = milestone.getAttribute('data-tier');
        const threshold = parseInt(milestone.getAttribute('data-threshold')) * 100;
        const productIdsAttr = milestone.getAttribute('data-product-ids');

        // Check conditions:
        // 1. Has product IDs
        // 2. Has threshold
        if (!productIdsAttr || !threshold) return;

        // Check if tier is achieved (cart total >= threshold)
        const isAchieved = cartTotal >= threshold;
        if (!isAchieved) return;

        // Parse product IDs
        const tierProductIds = productIdsAttr.split(',').map(id => id.trim());

        // Check if any of the tier products are already in cart
        const hasTierProductInCart = tierProductIds.some(productId => {
          return cartProductIds.has(productId);
        });

        // If none of the tier products are in cart, show the modal
        if (!hasTierProductInCart) {
          const modalId = `#modal-${tierNumber}`;
          const modalCommon = document.getElementById('modal-common');
          
          if (modalCommon && typeof modalCommon.show === 'function') {
            modalCommon.show(modalId);
            KROWN.settings.cart_action = 'overlay';
          }
          
          // Stop checking other tiers once we show one modal
          return;
        } else {
          // Tier product is already in cart - close the modal if it's open
          const modalId = `#modal-${tierNumber}`;
          const modalCommon = document.getElementById('modal-common');
          
          if (modalCommon && typeof modalCommon.hide === 'function' && modalCommon.classList.contains('active')) {
            modalCommon.hide();
          }
        }
      });
    }

    // Get cart product IDs from current DOM or fetch fresh cart data
    async getCartProductIds() {
      const productIds = new Set();
      
      // First try to get from current DOM
      const cartItems = document.querySelectorAll('[data-js-cart-item][data-product-id]');
      cartItems.forEach(item => {
        const productId = item.getAttribute('data-product-id');
        if (productId) {
          productIds.add(productId.toString());
        }
      });

      // If we found items, return them
      if (productIds.size > 0) {
        return productIds;
      }

      // Otherwise, fetch fresh cart data
      try {
        const response = await fetch('?section_id=helper-cart');
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        
        const fetchedItems = doc.querySelectorAll('[data-js-cart-item][data-product-id], [data-product-id]');
        
        fetchedItems.forEach(item => {
          const productId = item.getAttribute('data-product-id');
          if (productId) {
            productIds.add(productId.toString());
          }
        });

        return productIds;
      } catch (e) {
        console.error('Error fetching cart data:', e);
        return productIds;
      }
    }
  }

  customElements.define('cart-rewards-progress', CartRewardsProgress);
}

